import * as React from 'react';
import REACT_CONFIG from 'REACT_CONFIG';

const STEP1 = {
  target: '[data-tour="my-taxes__details"]',
  content: <p>Отображение подробной информации о начислениях, задолженностях и оплатах</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP2 = {
  target: '[data-tour="my-taxes__history"]',
  content: <p>Ведет на страницу с историей начислений и платежей</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP3 = {
  target: '[data-tour="my-taxes__manage"]',
  content: <p>Ведет на страницу подачи заявления на зачет и возврат переплаты</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP4 = {
  target: '[data-tour="my-taxes__income_inf"]',
  content: (
    <p>
      Ведет на страницу с историей справок о доходах, на которой можно посмотреть сумму налога,
      удержанную с дохода
    </p>
  ),
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP5 = {
  target: '[data-tour="my-taxes__checks"]',
  content: <p>Ведет на страницу добавления и просмотра кассовых чеков</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEP6 = {
  target: '[data-tour="mainmenu__incomeImage"]',
  content: <p>Страница для перехода в разделы «Мои декларации», «Упрощённые вычеты» и «Доходы"</p>,
  hideCloseButton: true,
  disableBeacon: true,
};
const STEPS_MY_TAXES = [STEP1, STEP2, STEP3, STEP4, STEP5, STEP6];

if (REACT_CONFIG.REACT_APP_HIDE_CHECKS) {
  //remove step5 if hide checks
  STEPS_MY_TAXES.splice(-2, 1);
}

export default STEPS_MY_TAXES;
